import React from 'react';
import PropTypes from 'prop-types';

import SingleActionButton from './single_action_button.jsx';
import GroupActionButton from './group_action_button.jsx';
import FormActionTypes from '../../constants/form_action_types';

export default class ActionButton extends React.Component {
	static propTypes = {
		type: PropTypes.oneOf(Object.values(FormActionTypes)),
	};

	getActionButtonComponentByType() {
		switch(this.props.type) {
			case FormActionTypes.GROUP:
			return GroupActionButton;
			default:
			return SingleActionButton;
		}
	}

	render() {
		const ActionButtonComponent = this.getActionButtonComponentByType();

		return (
			<ActionButtonComponent {...this.props} />
		);
	}
}
